import { Link } from "react-router-dom";
import FeatureCircle from "../components/FeatureCircle";

const Home = () => {
    return (
        <>
        <div className=' md:flex hidden justify-stretch w-full md:justify-center items-center '>
            <div className='absolute top-4 left-4 flex flex-col items-start md:items-center'>
                <img className='w-[22%]' src='./assets/icons/logo.svg' alt='logo' />
                <h1 className='text-primary md:text-center text-left font-bold text-xl lg:text-4xl'>
                    Financial Planning Tools
                    <br />
                    for Young People
                </h1>
            </div>
            <div className='flex relative flex-col mt-32 md:mt-0 md:py-0 w-full md:w-auto md:flex-row items-center space-y-2 md:space-y-0 md:space-x-20'>
                <Link to={"/fhc"} className="z-30">
                    <div className='w-48 h-48 md:w-60 group shadow-xl md:h-60 flex items-center justify-center rounded-full bg-gradient-to-r from-primary hover:from-philipine-silver to-patric-blue hover:to-cultured hover:scale-105 cursor-pointer duration-150'>
                        <h1 className='text-center font-bold text-2xl md:text-4xl text-white group-hover:text-primary'>
                            Financial
                            <br />Health
                            <br />
                            Checkup
                        </h1>
                    </div>
                </Link>
                <div className='halfcircle z-0 absolute w-60 h-32 top-[30%] md:w-72 md:h-36 md:top-1/2 md:-rotate-90 md:-left-7 -translate-y-1/2'></div>
                <div className='flex flex-col relative w-full md:w-auto md:h-auto'>
                    <div className='h-32 md:hidden'></div>
                    <div className='h-32 md:hidden'></div>
                    <Link to={'/bh'}>
                    <FeatureCircle heading={(<>Buying a<br /> Home</>)} classes={"absolute left-4 top-0 md:left-auto md:right-[160px] md:-top-[230px]"} />
                    </Link>
                    <Link to={'/as'}>
                    <FeatureCircle heading={(<>Allocate <br /> Savings</>)} classes={"absolute right-4 top-0 md:right-[60px] md:-top-[125px]"} />
                    </Link>
                    <Link to={'/dm'} >
                    <FeatureCircle heading={(<>Debt <br /> Management</>)} isLargeText classes={"md:static absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 md:translate-x-0 md:translate-y-0"} />
                    </Link>
                    <Link to={'/vp'}>
                    <FeatureCircle heading={(<>Value <br /> Spending</>)} classes={"absolute left-4 bottom-0 md:left-auto md:right-[60px] md:-bottom-[125px]"} />
                    </Link>
                  <Link to={'/sfg'}k>
                    <FeatureCircle heading={(<>Saving for <br />a Goal</>)} classes={"absolute right-4 bottom-0 md:right-[160px] md:-bottom-[230px]"} />
                  </Link>
                </div>
            </div>





            <div className='hidden md:block absolute bottom-4 z-0 left-0'>
                <img src='./assets/images/illustration.png' alt='illustration' />
            </div>
<div className="absolute   right-7   hidden md:block ">

            <div className="">
                <iframe className="rounded-lg" width={361} height={190} src="https://www.youtube.com/embed/tgbNymZ7vqY"></iframe>
            </div>
            <div className="w-[361px] py-4 border-[1px] shadow h-auto border-[#404EED] rounded-lg px-2 mt-2 h-auto" >

               <h1 className="text-center text-[#404EED] font-semibold Poppins">No one understands your life and<br></br>finances better than you do</h1>
               <h1 className="text-center mt-2 Poppins font-semibold ">Make your goals real with numbers using<br></br>self-serve intuitive tools</h1>

               <div className="border-[1px] my-3 mb-6 w-[261px] m-auto border-[#CACACA]"></div>

               <div className="m-auto ml-4 space-y-4 Poppins">

        
                            <li>Define  your   goals  to   be   financially<br></br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SMART </li>

                            <li> Get easy  to follow recommendations</li>

                            <li >We help you plan a  transformation or<br></br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;life goal </li>

                            <li>Peace of mind - do not share account<br></br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;details </li>

             
               </div>
            </div>
</div>

        </div>


<div className="w-full md:hidden block md:justify-center items-center">

        <div className='md:hidden flex justify-stretch w-full md:justify-center items-center '>
            <div className='absolute top-4 left-4 flex flex-col items-start md:items-center'>
                <img className='w-[22%]' src='./assets/icons/logo.svg' alt='logo' />
                <h1 className='text-primary md:text-center text-left font-bold text-xl lg:text-4xl'>
                    Financial Planning Tools
                    <br />
                    for Young People
                </h1>
            </div>
            <div className='flex relative flex-col mt-32 md:mt-0 md:py-0 w-full md:w-auto md:flex-row items-center space-y-2 md:space-y-0 md:space-x-20'>
                <Link to={"/fhc"} className="z-30">
                    <div className='w-48 h-48 md:w-60 group shadow-xl md:h-60 flex items-center justify-center rounded-full bg-gradient-to-r from-primary hover:from-philipine-silver to-patric-blue hover:to-cultured hover:scale-105 cursor-pointer duration-150'>
                        <h1 className='text-center font-bold text-2xl md:text-4xl text-white group-hover:text-primary'>
                            Financial
                            <br />Health
                            <br />
                            Checkup
                        </h1>
                    </div>
                </Link>
                <div className='halfcircle z-0 absolute w-60 h-32 top-[30%] md:w-72 md:h-36 md:top-1/2 md:-rotate-90 md:-left-7 -translate-y-1/2'></div>
                <div className='flex flex-col relative w-full md:w-auto md:h-auto'>
                    <div className='h-32 md:hidden'></div>
                    <div className='h-32 md:hidden'></div>
                    <Link to={'/bh'}>
                    <FeatureCircle heading={(<>Buying <br /> Homes</>)} classes={"absolute left-4 top-0 md:left-auto md:right-[160px] md:-top-[230px]"} />
                    </Link>
                    <Link to={'/as'}>
                    <FeatureCircle heading={(<>Allocate <br /> Savings</>)} classes={"absolute right-4 top-0 md:right-[60px] md:-top-[125px]"} />
                    </Link>
                    <Link to={'/dm'} >
                    <FeatureCircle heading={(<>Debt <br /> Management</>)} isLargeText classes={"md:static absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 md:translate-x-0 md:translate-y-0"} />
                    </Link>
                    <Link to={'/vp'}>
                    <FeatureCircle heading={(<>Value <br /> Spending</>)} classes={"absolute left-4 bottom-0 md:left-auto md:right-[60px] md:-bottom-[125px]"} />
                    </Link>
                  <Link to={'/sfg'}k>
                    <FeatureCircle heading={(<>Saving for <br />a Goal</>)} classes={"absolute right-4 bottom-0 md:right-[160px] md:-bottom-[230px]"} />
                  </Link>
                </div>
            </div>





            <div className='hidden md:block absolute bottom-4 z-0 left-0'>
                <img src='./assets/images/illustration.png' alt='illustration' />
            </div>


        </div>

            <div className="md:hidden block my-16 flex justify-center">
               <div>

              
            <div className="">
                <iframe className="rounded-lg" width={361} height={190} src="https://www.youtube.com/embed/tgbNymZ7vqY"></iframe>
            </div>
            <div className="w-[361px] py-4 border-[1px] shadow h-auto border-[#404EED] rounded-lg px-2 mt-2 h-auto" >

               <h1 className="text-center text-[#404EED] font-semibold Poppins">No one understands your life and<br></br>finances better than you do</h1>
               <h1 className="text-center mt-2 Poppins font-semibold ">Make your goals real with numbers using<br></br>self-serve intuitive tools</h1>

               <div className="border-[1px] my-3 mb-6 w-[261px] m-auto border-[#CACACA]"></div>

               <div className="m-auto ml-4 space-y-4 Poppins">

        
                            <li>Define  your   goals  to   be   financially<br></br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SMART </li>

                            <li> Get easy  to follow recommendations</li>

                            <li> Get easy  to follow recommendations</li>

                            <li >We help you plan a  transformation or<br></br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;life goal </li>

                            <li>Peace of mind - do not share account<br></br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;details </li>

             
               </div>
         </div>
            </div>
            </div>
</div>
        </>
    );
};

export default Home;